// Styles for AwardsRecognition go here.
import styled, { css } from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import rtl from 'styled-components-rtl';
import { GLOBAL_NAV_HEIGHT } from '../../modules/constants';

interface StyledStickyCardProps {
  $hasStickyNav?: boolean;
}

const stickyNavOffset = ({ $hasStickyNav }: StyledStickyCardProps) =>
  $hasStickyNav
    ? css`
        top: ${toRem(GLOBAL_NAV_HEIGHT.mobile)};
        @media ${baseVariables.mediaQuery.sm} {
          top: ${toRem(GLOBAL_NAV_HEIGHT.desktop)};
        }
      `
    : '';

const stickyHeaderTransition = ({ $hasStickyNav }: StyledStickyCardProps) => ($hasStickyNav ? 'top 0.4s ease' : 'none');

export const StyledStickyCard = styled.div<StyledStickyCardProps>`
  ${rtl`
    .sticky-card-container {
      box-shadow: ${baseVariables.shadows.shadowSubtle04};
      z-index: 100;
      transition: ${stickyHeaderTransition};
      ${stickyNavOffset}
    }
    .displayOnDesktop {
      display: none;
      @media ${baseVariables.mediaQuery.lg} {
        display: inline-block;
      }
    }
  `}
`;
